// extracted by mini-css-extract-plugin
export default {"navBar":"NavBar_navBar__P88J+","title":"NavBar_title__wxJC6","logo":"NavBar_logo__OGFVx"};